'use client';

import { c as _c } from "react/compiler-runtime";
import { Button } from '@achra/ui/button';
import { Card, CardContent } from '@achra/ui/card';
import Link from 'next/link';
import OperatorIcon from '@/modules/shared/components/svgs/operator-icon.svg';
interface AlreadyOperatorCardProps {
  /** Link to the user's Service Offering drive; absent if it can't be resolved. */
  operatorDriveLink?: string;
}

/**
 * Shown when a user arriving with operator intent has already completed
 * onboarding and is already an operator. Points them at their Service Offering
 * drive (where services are created) and the My Apps page.
 */
function AlreadyOperatorCard(t0) {
  const $ = _c(8);
  const {
    operatorDriveLink
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="bg-primary/10 text-primary flex size-12 items-center justify-center rounded-full"><OperatorIcon className="size-6" /></div>;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="flex flex-col gap-2"><h2 className="text-2xl font-semibold tracking-tight">You're already an operator</h2><p className="text-muted-foreground max-w-md text-sm">Use your Service Offering drive to start offering your own services to builders across Achra.</p></div>;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Button variant="outline" className="w-full min-w-0" asChild={true}><Link href="/my-account/apps">My Apps</Link></Button>;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  const t4 = !operatorDriveLink;
  let t5;
  if ($[3] !== operatorDriveLink) {
    t5 = operatorDriveLink ? <a href={operatorDriveLink} target="_blank" rel="noopener noreferrer">Open Service Offering</a> : <span aria-disabled="true">Open Service Offering</span>;
    $[3] = operatorDriveLink;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== t4 || $[6] !== t5) {
    t6 = <Card><CardContent className="flex flex-col items-center gap-5 px-8 py-12 text-center">{t1}{t2}<div className="grid w-full max-w-md grid-cols-1 gap-3 sm:grid-cols-2">{t3}<Button className="w-full min-w-0" asChild={true} disabled={t4}>{t5}</Button></div></CardContent></Card>;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  return t6;
}
export { AlreadyOperatorCard };